export default {
  SET_SUB_CATEGORY_PRODUCTS (state, sub_category_products) {
    state.sub_category_products = sub_category_products
  },
  REMOVE_RECORD (state, itemId) {
    const featureCategoryIndex = state.sub_category_products.findIndex((u) => u.id === itemId)
    state.sub_category_products.splice(featureCategoryIndex, 1)
  }
}
